import React, { createContext, useContext, useEffect, useState } from "react";

const InstallContext = createContext(null);

export function InstallProvider({ children }) {
  const [prompt, setPrompt] = useState(null);
  const [installed, setInstalled] = useState(false);

  useEffect(() => {
    const onPrompt = (e) => { e.preventDefault(); setPrompt(e); };
    const onInstalled = () => { setInstalled(true); setPrompt(null); };
    const standalone = window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone;
    if (standalone) setInstalled(true);
    window.addEventListener("beforeinstallprompt", onPrompt);
    window.addEventListener("appinstalled", onInstalled);
    return () => {
      window.removeEventListener("beforeinstallprompt", onPrompt);
      window.removeEventListener("appinstalled", onInstalled);
    };
  }, []);

  const isIOS = typeof navigator !== "undefined" && /iphone|ipad|ipod/i.test(navigator.userAgent);
  const install = async () => {
    if (!prompt) return "unavailable";
    prompt.prompt();
    const { outcome } = await prompt.userChoice;
    if (outcome === "accepted") setPrompt(null);
    return outcome;
  };

  const canInstall = !installed && (!!prompt || isIOS);

  return (
    <InstallContext.Provider value={{ canInstall, installed, install, hasPrompt: !!prompt, isIOS }}>
      {children}
    </InstallContext.Provider>
  );
}

export const useInstall = () => useContext(InstallContext);
